import { ValidateForm } from "react-admin";
import { validatePolicies } from "./policyValidation";
import { validateClaimants } from "./claimantValidation";
import { validateTasks } from "./taskValidation";
import { validateClients } from "./clientValidation";
import { validateReimbursements } from "./reimbursementValidation";
import { validateStoplossClaims } from "./stoplossClaimValidation";
import { validateClaimItems } from "./claimItemValidation";
import { ResourceName } from "@/types";
import { validatePartners } from "./partnerValidation";
import { validateTaskTemplates } from "./taskTemplateValidation";
import { validateVendor } from "./vendorValidation";

/**
 * Returns a validation function for a given resource.
 *
 * @param resource - The name of the resource (e.g., ResourceName.POLICIES)
 * @returns A React Admin ValidateForm function or undefined if not defined
 */
export const getResourceValidation = (resource: ResourceName): ValidateForm | undefined => {
  switch (resource) {
    case ResourceName.POLICIES:
      return validatePolicies as ValidateForm;
    case ResourceName.CLAIMANTS:
      return validateClaimants as ValidateForm;
    case ResourceName.TASKS:
      return validateTasks as ValidateForm;
    case ResourceName.CLIENTS:
      return validateClients as ValidateForm;
    case ResourceName.STOPLOSS_CLAIMS:
      return validateStoplossClaims as ValidateForm;
    case ResourceName.CLAIM_ITEMS:
      return validateClaimItems as ValidateForm;
    case ResourceName.REIMBURSEMENTS:
      return validateReimbursements as ValidateForm;
    case ResourceName.PARTNERS:
      return validatePartners as ValidateForm;
    case ResourceName.TASK_TEMPLATES:
      return validateTaskTemplates as ValidateForm;
    case ResourceName.VENDORS:
      return validateVendor as ValidateForm;
    default:
      return undefined;
  }
};
